<template>
  <div class="wrapper">
    <div class="header_wrapper">
      <v-toolbar color="primary" dark>
        <v-btn @click="routerBack" icon>
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title
          style="
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            margin: 0;
            padding: 0;
            max-width: 70%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
          class="text-center"
        >
          {{ childName }}
        </v-toolbar-title>
        <v-btn icon disabled style="visibility: hidden">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-toolbar>
    </div>

    <div>
      <div class="pa-1 grey-wrapper mt-4">
        <h5>支払方法</h5>
      </div>
      <v-radio-group
        v-model="selectedCategory"
        @change="selectCategory"
        class="px-2">
        <v-radio
          v-for="m in paymentCategories"
          :key="m.type"
          :label="`${m.name}`"
          :value="m.type"
          color="primary"></v-radio>
      </v-radio-group>
    </div>

    <div v-if="selectedCategory === 'card'">
      <vue-loading
        v-if="cardFetchLoading"
        :active="cardFetchLoading"
        loader="bars"
        color="#EE6090"
        :size="{ width: '30px', height: '30px' }"></vue-loading>
      <div v-else>
        <div class="d-flex justify-center pa-1 grey-wrapper"
          style="margin-top: 17px;">
          <h5>クレジットカード</h5>
          <v-spacer></v-spacer>
          <v-btn
            v-if="cards.length > 0"
            @click="toRegister()"
            depressed
            rounded
            color="info"
            class="px-3"
            x-small>
            カード情報追加
          </v-btn>
        </div>

        <v-card v-if="cards.length === 0" class="ma-2 pa-3">
          <div class="mb-5">
            <p>未登録</p>
          </div>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn @click="toRegister()" depressed rounded color="info" class="px-3" small>
              カード情報追加
            </v-btn>
          </div>
        </v-card>

        <v-card
          v-else
          v-for="c in cards"
          :key="c.cardSeq"
          @click="selectedCardSeq = c.cardSeq"
          :class="`ma-2 pa-3 ${
            selectedCardSeq === c.cardSeq ? 'card_active' : ''
          }`">
          <div v-if="isUsingCard(c.cardSeq)" class="d-flex">
            <v-spacer></v-spacer>
            <p>使用中<v-icon>mdi-checkbox-marked-outline</v-icon></p>
          </div>

          <div>
            <p class="mb-1">
              <span class="mr-1">{{ c.cardName }}</span>
              {{ c.cardNo }}
            </p>
            <p class="mb-1">{{ c.holderName }}</p>
            <p class="body-2">有効期限 {{ getExpireString(c.expire) }}</p>
          </div>

          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn
              @click="deletePaymentMethodCard(c.cardSeq)"
              :loading="deleteBtnLoading"
              class="ml-2"
              depressed
              rounded
              color="error"
              small>
              削除
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>

    <div class="d-flex justify-center mt-5">
      <v-btn
        class="mb-5"
        @click="putPaymentMethod"
        :loading="putBtnLoading"
        color="primary">
        登録
      </v-btn>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { Toast } from '@/service/SweetAlert';
import Swal from 'sweetalert2';

import { familyModule } from '@/store/entityModules/family';
import { paymentModule } from '@/store/entityModules/payment';

import { PaymentMethodResponse } from '@API/src/component/home/payment/types';

interface DataType {
  childId: number;
  childName: string;
  fetchLoading: boolean;
  cardFetchLoading: boolean;
  putBtnLoading: boolean;
  deleteBtnLoading: boolean;
  selectedCategory: string | null;
  selectedCardSeq: string;
  paymentCategories: Array<{
    type: string;
    name: string;
  }>;
}

export default defineComponent({
  name: 'Payment',

  components: {
    'vue-loading': Loading,
  },

  data: (): DataType => ({
    childId: NaN,
    childName: '',
    fetchLoading: false,
    cardFetchLoading: false,
    putBtnLoading: false,
    deleteBtnLoading: false,
    selectedCategory: null,
    selectedCardSeq: '',
    paymentCategories: [
      {
        type: 'card',
        name: 'クレジットカード',
      },
      // {
      //   type: 'withdrawal',
      //   name: '口座引き落とし',
      // },
      // {
      //   type: 'invoice',
      //   name: '振り込み',
      // },
    ],
  }),

  computed: {
    family() {
      return familyModule.family;
    },
    payment() {
      if (this.childId && paymentModule.payments.length > 0) {
        const payment = paymentModule.payments.find((p) => {
          if (p.child.childId === this.childId) {
            return p;
          }
        });
        return payment ? payment : null;
      } else {
        return null;
      }
    },
    selectedCard() {
      if (this.childId && paymentModule.payments.length > 0) {
        const payment = paymentModule.payments.find((p) => {
          if (p.child.childId === this.childId) {
            return p;
          }
        });
        if (payment && payment.card) {
          return payment.card;
        }
        return null;
      } else {
        return null;
      }
    },
    cards() {
      return paymentModule.cards;
    },
  },

  watch: {
    payment: {
      handler(val: PaymentMethodResponse | null) {
        if (val !== null) {
          if (val.category === null) {
            this.selectedCategory = 'invoice';
          } else {
            this.selectedCategory = val.category;
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    routerBack() {
      this.$router.replace('/payment/select');
    },
    toRegister() {
      const childId = String(this.childId);
      const childName = this.childName;
      this.$router.push({
        name: 'PaymentRegister',
        query: {
          childId,
          childName,
        },
      });
    },
    isUsingCard(cardSeq: string) {
      return cardSeq === this.selectedCard?.cardSeq;
    },
    getExpireString(expire: string) {
      const str = expire.slice(0, 2) + '/' + expire.slice(2);
      return str;
    },
    selectCategory(category: string) {
      if (this.selectedCategory === 'card' && this.selectedCardSeq === '') {
        if (this.cards.length > 0) {
          this.selectedCardSeq = this.cards[0].cardSeq;
        }
      }
    },
    async fetchPaymentCardMethod() {
      this.cardFetchLoading = true;
      if (this.family) {
        const familyId = this.family.familyId;
        const response = await paymentModule.fetchPaymentCardMethod({
          familyId,
        });
      }
      this.cardFetchLoading = false;
    },
    async putPaymentMethod() {
      this.putBtnLoading = true;
      if (!this.selectedCategory) {
        Swal.fire({
          icon: 'warning',
          title: '支払方法を選択してください',
        });
      }
      if (this.selectedCategory === 'card' && !this.selectedCardSeq) {
        Swal.fire({
          icon: 'warning',
          title: 'クレジットカードが\n登録・選択\nされていません',
        });
        return;
      }
      if (this.payment && this.selectedCategory) {
        const response = await paymentModule.putPaymentMethod({
          childId: this.payment.child.childId,
          category: this.selectedCategory,
          cardSeq: this.selectedCardSeq ? this.selectedCardSeq : null,
        });
        if (response) {
          Swal.fire({
            icon: 'success',
            title: '保存が完了しました',
            padding: '1rem 0',
          });
        }
      }
      this.putBtnLoading = false;
    },
    async deletePaymentMethodCard(cardSeq: string) {
      this.deleteBtnLoading = true;
      if (this.family) {
        const familyId = this.family.familyId;
        Swal.fire({
          title: '<span style="font-size: 23px;">カード情報を削除しますか?</span>',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#FF3F3A',
          cancelButtonColor: '#BDBDBD',
          confirmButtonText: '削除',
          cancelButtonText: 'キャンセル',
          padding: '1rem 0',
          allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.showLoading();
            const response = paymentModule.deletePaymentCardMethod({
              familyId,
              cardSeq,
            });
            Toast.fire({
              icon: 'success',
              title: '削除が完了しました',
            });
          }
          this.deleteBtnLoading = false;
        });
      }
    },
    async cardCheck () {
      if (!this.selectedCard) {
        Swal.fire({
            icon: 'warning',
            title: "<span style='font-size: 23px;'>決済カードの<br>登録ができていません</span>",
            html: "<span style='font-size: 15px;'>カード登録を行い、情報をタップし「登録」ボタンを押してください。<br>カード情報右上に「使用中」と表示されると登録完了です。</span>",
          });
      }
    }
  },

  async mounted() {
    if (typeof this.$route.query.childName === 'string') {
      this.childName = this.$route.query.childName;
    }
    if (typeof this.$route.query.childId === 'number') {
      this.childId = this.$route.query.childId;
    } else if (typeof this.$route.query.childId === 'string') {
      this.childId = Number(this.$route.query.childId);
    } else {
      this.routerBack();
    }

    if (!this.family) {
      this.routerBack();
    }

    if (this.payment) {
      this.selectedCategory = this.payment.category;
      if (this.payment.card) {
        this.selectedCardSeq = this.payment.card.cardSeq;
      }
    } else {
      this.routerBack();
    }

    this.fetchPaymentCardMethod();

    this.cardCheck ()
    
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
// リストはヘッダー分だけ下げる
.v-list {
  margin-top: calc(env(safe-area-inset-top));
}
.grey-wrapper {
  color: #a3a4a4;
  background-color: #f5f6f6;
}
.card_active {
  background-color: rgb(var(--v-theme-primary));
  color: #ffffff;
}
</style>
